import { TransactionRequestDetailScreen } from "@/screens/dashboard/TransactionRequestDetailScreen";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/transactions/$requestId")({
  component: TransactionRequestDetailScreen,
  loader: async ({ params }) => {
    return {
      crumb: "Detail Permintaan",
      requestId: params.requestId,
    };
  },
});
